<template>

  <div class="float-w show" v-if="isShow">
    <div class="float--w">
      <div class="float-tt display-600 not-display-pc">
        <span class="zh">视频资料</span>
        <span class="en"></span>
      </div>
      <div class="btn-close" @click="close()">
        <img src="@/assets/images/icon-close-blk.png" alt="close"/>
      </div>
      <div class="main-bb">
        <div class="video-w">
          <div class="video--w">
            <video ref="floatVideo" :src="videos[index].url"></video>
            <div class="op-w" @click="playVideo()" v-if="!floatVideoPlay">
              <img class="btn-play" src="@/assets/images/icon-play-wht.png" alt="play"/>
            </div>
          </div>
          <p class="hint" v-if="videos[index].alt">{{ videos[index].alt }}</p>
        </div>

      </div>
      <div class="sub-slides-w">
        <swiper v-if="swiperOptionVideoFloatThumbs" :options="swiperOptionVideoFloatThumbs" ref="swiperThumbsVideo">
          <swiper-slide v-for="(item,index) in videos" :key="index">
            <div class="bbc" @click="changeVideo(index)">
              <img class="cover" :src="item.cover.s" alt="artist"/>
              <div class="op-w">
                <img class="btn-play" src="@/assets/images/icon-play-wht.png" alt="play"/>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  components: {},
  props: {
    index: {
      type: Number,
      default: null,
    },
    videos: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      swiperOptionVideoFloatThumbs: null,
      floatVideoSrc: null,
      floatVideoPlay: false,
      isShow: false,
      key: null
    }
  },
  created() {
    this.key = this.index;
    this.show();

    this.$nextTick(() => {
      this.swiperOptionVideoFloatThumbs = {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        slideToClickedSlide: true,
        centeredSlides: true,
        breakpoints: {
          1200: {
            spaceBetween: 32,
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
          },
          1600: {
            spaceBetween: 32,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          }
        }
      };
    })
  },
  methods: {
    show() {
      this.isShow = true;
      document.body.style.overflow = "hidden";
    },
    close() {
      this.isShow = false;
      document.body.style.overflow = "auto";
    },
    playVideo() {
      this.floatVideoPlay = true;
      this.$refs.floatVideo.play()
      this.$refs.floatVideo.setAttribute("controls", "controls")
    },
    changeVideo(index) {
      this.$refs.floatVideo.pause()
      this.floatVideoPlay = false;
      this.key = index;
      this.$refs.floatVideo.removeAttribute("controls")
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page/videos.vue